import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {CartQuantityNotifier} from "../domain/cart-quantity-notifier";
import {CartLine} from "../domain/dtos/cart-line";
import {CartLineRepository} from "./cart-line-repository.service";
import {TrackRemoveFromCartUseCase} from "@app/core/tracking/application/track-remove-from-cart.use-case";

/**
 * Use case for removing a promotion from the cart.
 */
@Injectable({
    providedIn: "root",
})
export class RemovePromotionUseCase {
    constructor(
        private cartLineRepository: CartLineRepository,
        private cartController: CartQuantityNotifier,
        private trackRemoveFromCartUseCase: TrackRemoveFromCartUseCase,
    ) { }

    /**
     * Remove a promotion from the cart.
     * @param promotionCode - Code of the promotion to remove.
     * @return Removed cart lines.
     */
    execute(promotionCode: string): Observable<CartLine[]> {
        return this.cartLineRepository.removePromotion(promotionCode).pipe(
            tap(() => this.cartController.notifyCartQuantityChanged()),
            tap(cartLines => this.trackRemoveFromCartUseCase.execute({
                items: cartLines.map(cartLine => ({itemId: cartLine.code, itemName: cartLine.name})),
                value: cartLines.reduce((acc, cartLine) => acc + (cartLine.price ?? 0) * cartLine.quantity, 0),
            })),
        );
    }
}
